/* eslint-disable */
import {AfterViewInit, Component, Input, OnInit, ViewChild,} from '@angular/core';
import { TaskRecord, TaskRecordService } from '../../../../lib/task/task-record.service';
import { NamedBlobFile, } from '../../../../lib/util/downloaded-files';
import { Observable } from 'rxjs';
import { FileAttachment, FileAttachments, FileAttachmentUpdateRequest } from '../../../../lib/util/file-attachments';
import { RightResolver, RightService } from '../../../../lib/right.service';
import { RightModel } from '../../../../app.rights';
import {
  MaterialAttachmentGalleryComponent,
  ThumbnailLoaderFactory
} from '../../../../shared/material-attachment-gallery/material-attachment-gallery.component';
import { BaseHttpService } from '../../../../lib/util/http-services';
import { EmptyMessage } from '../../../../lib/util/messages';
import {CustomerRecordRightModel} from "../../../../util/customer-record-utils";
import {TaskRecordRightModel} from "../../../../util/task-record-utils";
import {map} from "rxjs/operators";

/* eslint-enable */

@Component({
  selector: 'app-task-record-attachment',
  templateUrl: './task-record-attachment.component.html',
  styleUrls: ['./task-record-attachment.component.scss'],
})
export class TaskRecordAttachmentComponent implements OnInit, AfterViewInit, ThumbnailLoaderFactory {

  @Input()
  taskRecordId: number;

  @Input()
  readonly: boolean;

  @Input()
  taskId: number;

  fileLoaderFactory = this;

  @Input()
  grantedRights: TaskRecordRightModel;

  @ViewChild("gallery")
  gallery: MaterialAttachmentGalleryComponent;

  constructor(private taskRecordService: TaskRecordService,
              private rightService: RightService) {
  }

  getUploadPath(): string {
    return '/tasks/' + this.taskId + '/records/' + this.taskRecordId + '/attachments?' + BaseHttpService.LOCATION_ON;
  }

  ngOnInit() {
  }

  public showData() {
    if (this.grantedRights.attachmentRead.hasRight()) {
      this.gallery.showData();
    }
  }

  loadAttachments() {
    return this.taskRecordService.getAttachments({
      taskRecordId: this.taskRecordId,
      taskId: this.taskId,
    });
  }

  loadAttachment(id: number): Observable<FileAttachment | undefined> {
    return this.taskRecordService.getAttachments({
      taskRecordId: this.taskRecordId,
      taskId: this.taskId,
    }).pipe(map(result => {
      return result.find(r => r.id === id);
    }));
  }

  deleteAttachment(fileId: number) {
    return this.taskRecordService.deleteAttachment({
      taskId: this.taskId,
      taskRecordId: this.taskRecordId,
      fileId: fileId
    });
  }

  public createFileLoader(attachment: FileAttachment): Observable<NamedBlobFile> {
    return this.taskRecordService.downloadAttachment({
      taskId: this.taskId,
      taskRecordId: this.taskRecordId,
      attachment: attachment,
    });
  }

  hasThumbnails(): boolean {
    return true;
  }

  createThumbnailLoader(attachment: FileAttachment): Observable<NamedBlobFile> {
    return this.taskRecordService.downloadAttachmentThumbnail({
      taskId: this.taskId,
      taskRecordId: this.taskRecordId,
      attachment: attachment,
    });
  }

  updateAttachment(r: FileAttachmentUpdateRequest): Observable<EmptyMessage> {
    const request: TaskRecord.UpdateAttachmentRequest = {
      name: r.name,
      fileId: r.fileId,
      taskId: this.taskId,
      taskRecordId: this.taskRecordId
    };
    return this.taskRecordService.updateAttachment(request);
  }

  ngAfterViewInit(): void {
  }

}
